module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjBAMAAADs965qAAAAMFBMVEUAAAA8WpY1WpY3WpY4Vpo5V5k3WJk4WJg4WJg5WJg4WZg4WZc4WJk5WJg4WJg4WJj2hAGiAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAr0lEQVQoz63RMQrCQBBA0W8iWChYW2ljnyOksFdbq4AHiN2UegYv4BE8wBY5QmysA14gjSAqZCwUNrtbKf7yDQwDA0QzWwJAr1Jbswc6pbZrEuir2wVyj+5w9EjBLn8uYayaYscZMHToRkCnkHawMoVDGyJVdWhB16f0N+LdPKQ8pG1Ih5Da1xuTEBtT/+PU76kKqfCp9e0PPWDg0RXi2qUMGDl0BmAqIiIyIRJZAy/PKsDXTGT/OQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/facebook.png
// module id = 257
// module chunks = 0